import React from 'react';
import AppRoutes from './routes/appRoutes';
import GlobalStyles from './GlobalStyles';
import { AppThemeProvider } from './shared/contexts/AppThemeProvider';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/login/SinginProvider';
import { EnvBadge } from './shared/components/EnvBadge';
import { PermissaoProvider } from './context/permissao/PermissaoProvider';
import { ErrorBoundary } from './shared/components/ErrorBoundary';

const App = () => {
  return (
    <React.Fragment>
      <AppThemeProvider>
        <GlobalStyles />
        <EnvBadge />
        {/* [23/10] Em volta de TUDO que desenha tela. Sem ele, um erro em qualquer
            componente apaga a aplicacao inteira e deixa a tela branca, sem uma palavra
            - foi o card [VENDAS] BUG TELA EM BRANCO. Fica por fora dos providers de
            proposito: se o erro nascer dentro de um deles, ainda ha quem o pegue. */}
        <ErrorBoundary>
        <AuthProvider>
          {/* [22/10] As telas do usuário. DENTRO do AuthProvider e FORA do BrowserRouter:
              precisa do token para perguntar, e precisa existir antes de qualquer rota
              ser desenhada - é ele que diz se a rota pode abrir. */}
          <PermissaoProvider>
            <BrowserRouter>
              <AppRoutes />
            </BrowserRouter>
          </PermissaoProvider>
        </AuthProvider>
        </ErrorBoundary>
      </AppThemeProvider>
    </React.Fragment>
  );
};

export default App;
